import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const DryCleaningIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "DryCleaningIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.5659 2.05438H5.43454C4.79188 2.05438 4.26904 2.57722 4.26904 3.21988V21.3629C4.26904 21.6847 4.52996 21.9456 4.85179 21.9456H19.1486C19.4705 21.9456 19.7314 21.6847 19.7314 21.3629V3.21988C19.7314 2.57722 19.2085 2.05438 18.5659 2.05438ZM18.5659 3.21988V7.06604H5.43454V3.21988H18.5659ZM5.43454 20.7801V8.23155H18.5659V20.7801H5.43454Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.1758 5.74514H16.3514C16.6733 5.74514 16.9342 5.48422 16.9342 5.16239C16.9342 4.84056 16.6733 4.57964 16.3514 4.57964H14.1758C13.854 4.57964 13.5931 4.84056 13.5931 5.16239C13.5931 5.48422 13.854 5.74514 14.1758 5.74514Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.2842 12.0374C16.2842 12.0373 16.2843 12.0375 16.2842 12.0374C15.4065 10.5047 13.7649 9.55245 12.0002 9.55245C9.2796 9.55245 7.06624 11.7658 7.06624 14.4864C7.06624 17.207 9.27961 19.4204 12.0002 19.4204C13.7649 19.4204 15.4064 18.4683 16.2841 16.9357C16.2841 16.9357 16.2841 16.9356 16.2841 16.9357C16.7093 16.1931 16.9342 15.346 16.9342 14.4864C16.9342 13.6269 16.7094 12.78 16.2842 12.0374ZM15.4643 13.0008C15.6643 13.4677 15.7687 13.974 15.7687 14.4864C15.7687 14.9988 15.6642 15.5051 15.4643 15.972C14.8645 15.7399 14.4478 15.1567 14.4478 14.4864C14.4478 13.8161 14.8645 13.2329 15.4643 13.0008ZM12.0002 18.2549C9.92227 18.2549 8.23175 16.5644 8.23175 14.4864C8.23175 12.4085 9.92227 10.718 12.0002 10.718C13.0947 10.718 14.1272 11.1976 14.8358 12.0048C13.9094 12.4548 13.2823 13.405 13.2823 14.4864C13.2823 15.5678 13.9094 16.518 14.8358 16.968C14.1272 17.7753 13.0947 18.2549 12.0002 18.2549Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.3382 5.74518C7.66005 5.74518 7.92095 5.48428 7.92095 5.16243C7.92095 4.84059 7.66005 4.57968 7.3382 4.57968C7.01636 4.57968 6.75545 4.84059 6.75545 5.16243C6.75545 5.48428 7.01636 5.74518 7.3382 5.74518Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.8246 5.74518C10.1464 5.74518 10.4074 5.48428 10.4074 5.16243C10.4074 4.84059 10.1464 4.57968 9.8246 4.57968C9.50276 4.57968 9.24185 4.84059 9.24185 5.16243C9.24185 5.48428 9.50276 5.74518 9.8246 5.74518Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default DryCleaningIcon;
